import { Divider, Grid, MenuItem, styled } from "@mui/material";
import React, { memo } from "react";
import { useBuildingDetailUnidContext } from "../../../../context/BuildingDetailUnidContext";
import MxMenu, { MxMenuItemProps } from "@rf-l1/MxMenu";
import MxIcons from "@rf-l1/MxIcons";
import {
  IconArrowRight,
  IconCopy,
  IconDotsVertical,
  IconPencil,
  IconTrash
} from "@tabler/icons-react";
import MxTypography from "@rf-l1/MxTypography";
import MxInputNumberField from "@rf-l1/form/text-fields/MxInputNumberField";
import useModal from "@rf/base/modal/useModal";
import BuildingUnitFormModal from "./unit-modal/BuildingUnitFormModal";
import { useFormContext } from "react-hook-form";
import { usePropertyFormFeaturesState } from "../../../../../../../store/slices/FormFeaturesSlice";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import useValidateExplicitField from "../../../../../documentation-step/validations-project/validation-documents/hooks/useValidateExplicitField";
import { useUnitsContext } from "@rf/property/module/components/property-form/septions/property-steps/buildings-step/context/UnitsContext";

const BuildingUnitFormOptionsSection = memo(() => {
  const { getValues, setValue } = useFormContext();
  const { validateField } = useValidateExplicitField();
  const { indexUnit, nameUnit } = useBuildingDetailUnidContext();
  const { deleteUnit, duplicateUnit } = useUnitsContext();
  const { modal } = useModal();
  const { forProject } = usePropertyFormFeaturesState();

  const OpenModal = () => {
    const res = modal({
      template: <MxModalTemplate2 children={<BuildingUnitFormModal />} />,
      data: {
        getValues: getValues,
        setValue: setValue,
        indexUnit: indexUnit,
        feature: forProject,
        unitName: nameUnit
      },
      options: {
        style: {
          width: "100%",
          maxWidth: 600
        }
      }
    });
    res.then(v => {
      if (v.type.confirm) {
        validateField(nameUnit);
      }
    });
  };
  const options: MxMenuItemProps<any>[] = [
    {
      label: "Editar",
      icon: <IconPencil size={18} />,
      show: true,
      onClick: () => OpenModal()
    },
    {
      label: "Copiar unidad",
      icon: <IconCopy size={18} />,
      show: true,
      onClick: () => duplicateUnit(indexUnit)
    },
    {
      label: "Duplicar unidad",
      icon: <IconCopy size={18} />,
      show: true,
      onClick: (e: any) =>
        duplicateUnit(indexUnit, Number(e.context.detail.count || 1)),
      template: <DuplicateCount />
    },
    {
      label: "Eliminar unidad",
      icon: <IconTrash size={18} />,
      show: true,
      color: "error.light",
      onClick: () => deleteUnit(indexUnit)
    }
  ];

  return (
    <Grid container item flex={1}>
      <Divider flexItem orientation="vertical" />
      <ContentUnit container flex={1}>
        <MxMenu items={options} width={270}>
          <MxIcons size={16} color="primary.main">
            <IconDotsVertical />
          </MxIcons>
        </MxMenu>
      </ContentUnit>
    </Grid>
  );
});

export default BuildingUnitFormOptionsSection;

const ContentUnit = styled(Grid)(({ theme }) => ({
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiOutlinedInput-root": {
    borderRadius: 0,
    "*": {
      border: `0px`
    }
  }
}));

export const DuplicateCount = (props: any) => {
  const [count, setCount] = React.useState(1);

  const handleCount = (e: any) => {
    setCount(e.target.value);
  };

  const handleSubmit = () => {
    props.onClick?.({ count: count });
  };

  return (
    <MenuItem>
      <Grid container spacing={1} alignItems={"center"}>
        <Grid item xs="auto">
          <MxIcons color="grey.600" size={16} children={<IconCopy size={18} />} />
        </Grid>
        <Grid item xs={6}>
          <MxTypography color="grey.600" variant="button" children="Duplicar por" />
        </Grid>
        <Grid item xs="auto">
          <MxInputNumberField
            sx={{
              width: "100%",
              maxWidth: 60,
              "& input": {
                textAlign: "center",
                height: 22
              }
            }}
            value={count}
            onChange={handleCount}
            size="small"
          />
        </Grid>
        <Grid item xs={1}>
          <MxIcons
            onClick={handleSubmit}
            color="grey.500"
            size={16}
            children={<IconArrowRight size={18} />}
          />
        </Grid>
      </Grid>
    </MenuItem>
  );
};
